import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { IMAGES } from "@/lib/data";

export default function BlueprintSlider() {
  const [pos, setPos] = useState(55);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setPos(Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100)));
  };

  const onPointerDown = (e) => {
    dragging.current = true;
    e.currentTarget.setPointerCapture?.(e.pointerId);
    update(e.clientX);
  };
  const onPointerMove = (e) => {
    if (dragging.current) update(e.clientX);
  };
  const stop = () => {
    dragging.current = false;
  };

  return (
    <div
      ref={ref}
      data-testid="blueprint-compare-slider"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerLeave={stop}
      className="relative aspect-[16/10] cursor-ew-resize touch-none select-none overflow-hidden rounded-md border border-white/10 sm:aspect-[16/8]"
    >
      <img
        src={IMAGES.luxury}
        alt="Retail interior site photograph"
        className="absolute inset-0 h-full w-full object-cover"
        draggable="false"
      />
      <span className="absolute left-4 top-4 z-10 rounded-sm border border-white/20 bg-canvas/70 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-300 backdrop-blur-sm">
        Site photo
      </span>

      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img
          src={IMAGES.luxury}
          alt="As-built CAD interpretation of the same space"
          className="blueprint-photo absolute inset-0 h-full w-full object-cover"
          draggable="false"
        />
        <div className="absolute inset-0 bg-blueprint/35 mix-blend-multiply" />
        <div className="blueprint-grid absolute inset-0" />
        <svg className="absolute inset-0 h-full w-full" preserveAspectRatio="none" viewBox="0 0 100 100">
          <line x1="8" y1="88" x2="70" y2="88" stroke="#38BDF8" strokeWidth="0.25" />
          <line x1="8" y1="86" x2="8" y2="90" stroke="#38BDF8" strokeWidth="0.25" />
          <line x1="70" y1="86" x2="70" y2="90" stroke="#38BDF8" strokeWidth="0.25" />
          <line x1="12" y1="14" x2="12" y2="58" stroke="#F59E0B" strokeWidth="0.25" />
          <line x1="10" y1="14" x2="14" y2="14" stroke="#F59E0B" strokeWidth="0.25" />
          <line x1="10" y1="58" x2="14" y2="58" stroke="#F59E0B" strokeWidth="0.25" />
        </svg>
        <span className="absolute bottom-[10%] left-[24%] font-mono text-[10px] tracking-[0.2em] text-cad">
          62'-04" / 18.90 M
        </span>
        <span className="absolute left-[4%] top-[32%] -rotate-90 font-mono text-[10px] tracking-[0.2em] text-laser">
          14'-06" / 4.42 M
        </span>
        <span className="absolute left-4 top-4 rounded-sm border border-cad/40 bg-canvas/70 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-cad backdrop-blur-sm">
          As-built / CAD
        </span>
      </div>

      <div
        className="absolute inset-y-0 z-10"
        style={{ left: `${pos}%`, transform: "translateX(-50%)" }}
      >
        <div className="h-full w-px bg-cad shadow-[0_0_16px_rgba(56,189,248,0.8)]" />
        <div className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-cad/60 bg-canvas/90 text-cad shadow-[0_0_24px_rgba(56,189,248,0.4)]">
          <MoveHorizontal size={18} />
        </div>
      </div>
    </div>
  );
}
